import React, { SVGProps } from 'react';

export const Redo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M22.938 15.646a12.162 12.162 0 0 1-.98 2.42l.033-.066a10.285 10.285 0 0 1-3.938 3.949l-.052.026a12.043 12.043 0 0 1-6.007 1.424 12.147 12.147 0 0 1-6.058-1.457l.065.033a10.291 10.291 0 0 1-3.964-3.925L2.011 18A12.096 12.096 0 0 1 .6 11.99l-.002-.176c0-2.135.557-4.139 1.533-5.876l-.032.06A10.111 10.111 0 0 1 5.951 2.05l.05-.026A12.034 12.034 0 0 1 12.01.598a12.204 12.204 0 0 1 5.99 1.5 10.192 10.192 0 0 1 3.1 2.6V1h1.8v6.8H16V6.1h3.882a8.367 8.367 0 0 0-2.74-2.478L17.1 3.6a10.367 10.367 0 0 0-5.105-1.2 10.455 10.455 0 0 0-5.152 1.228L6.9 3.6a8.417 8.417 0 0 0-3.278 3.273l-.022.043A10.174 10.174 0 0 0 2.4 12.008c-.001.07-.003.151-.003.233 0 1.773.446 3.441 1.23 4.9l-.027-.055a8.31 8.31 0 0 0 3.272 3.293l.042.022a10.195 10.195 0 0 0 5.093 1.2l.214.002c1.784 0 3.465-.445 4.936-1.23l-.056.028a8.366 8.366 0 0 0 3.278-3.287l.022-.043c.334-.62.608-1.292.81-2.001l1.727.576ZM12.007 21.6H12h.013-.006ZM2.4 12.008V12v.013-.006ZM11.995 2.4H12h-.011.006Z"
    />
  </svg>
);
